import styled from '@emotion/styled'

import LinkIcon from '@/assets/link.png'

export const Img = styled.img`
  top: -1px;
  cursor: pointer;
  margin-bottom: 0;
  position: relative;
`

export const MainBody = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
  text-align: center;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`

export const BackBtnContainer = styled.div`
  width: 80rem;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 16px;
  }
`

export const BackBtn = styled.div`
  cursor: pointer;
  width: 32px;
`

export const DetailAddr = styled.div`
  width: 80rem;
  border-radius: 16px;
  backdrop-filter: blur(50px);
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
  }
`

export const DetailInfo = styled.div`
  width: 80rem;
  height: 35rem;
  border-radius: 16px;
  backdrop-filter: blur(50px);
  padding: 5px 20px;

  @media (max-width: 768px) {
    width: 100%;
    height: 95rem;
  }
`

export const Btn = styled.div`
  width: 80rem;
  .ant-btn {
    border-radius: 16px;
    height: 60px;
    color: white;
    border: none;
    background: #0f68aa;
  }
  .ant-btn:hover {
    background: #0f68aa;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 2rem;
  }
`

export const MyDelegate = styled.div`
  width: 80rem;
  border-radius: 16px;
  opacity: 1;
  padding: 10px 20px;
  backdrop-filter: blur(30px);
  gap: 1rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const DetailAddr1 = styled.div`
  width: 90px;
  line-height: 90px;
`

export const DetailAddr2 = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 90px;
  justify-content: center;
  align-items: flex-start;
  p {
    margin-bottom: 0;
  }
`

export const InfoRow = styled.div<{
  count?: number
  direction?: string
}>`
  width: 100%;
  display: flex;
  height: ${(props) => `calc(100% / ${props.count || 4})`};
  flex-direction: ${(props) => props.direction || 'row'};

  @media (max-width: 768px) {
    flex-direction: column;
    height: initial;
    justify-content: space-around;
    margin: 2rem 0;
  }
`

export const LineRow = styled.div<{
  isdark: boolean
}>`
  border-bottom: ${(props) =>
    props.isdark ? '1px solid #1E3546' : '1px solid #EBEFF2'};
  width: 100%;
`

export const Data = styled.div`
  display: inline-block;
  width: 50%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin-bottom: 0;
    font-weight: bold;

    span:first-of-type {
      font-size: 32px;
      display: inline-block;
      margin-right: 10px;
    }
    span:not(:first-of-type) {
      font-size: 12px;
      color: #757575;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const LineCloumn = styled.div<{
  isdark: boolean
}>`
  height: 100%;
  border-left: ${(props) =>
    props.isdark ? '1px solid #1E3546' : '1px solid #EBEFF2'};
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100;
    border-bottom: ${(props) =>
      props.isdark ? '1px solid #1E3546' : '1px solid #EBEFF2'};
    border-left: 0;
  }
`

export const DataTitle = styled.span<{
  color?: string
}>`
  font-size: 16px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  color: ${(props) => props.color || '#757575'};
  position: relative;
`

export const BtnArea = styled.div<{
  isdark: boolean
}>`
  display: inline-flex;
  justify-content: space-between;
  gap: 20px;

  span {
    font-size: 16px !important;
    display: inline-block;
    margin-right: 0 !important;
  }
  .ant-btn:last-of-type {
    background: ${(props) => (props.isdark ? '#051f31' : '#fff')};
    border-radius: 16px;
    border: 1px solid #2fbdf4;
    color: #2fbdf4;
  }
  .ant-btn:last-of-type:hover {
    background: ${(props) => (props.isdark ? '#051f31' : '#fff')};
  }
  .ant-btn {
    width: 120px;
    border-radius: 16px;
    height: 35px;
    color: white;
    border: none;
    background: #0f68aa;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-btn:hover {
    background: #0f68aa;
  }

  @media (max-width: 768px) {
    justify-content: space-around;
    margin-top: 2rem;
  }
`

export const Data1 = styled.div`
  display: inline-block;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    margin-bottom: 0;
    font-weight: bold;

    span:first-of-type {
      font-size: 32px;
      display: inline-block;
      margin-right: 10px;
    }
    span:not(:first-of-type) {
      font-size: 12px;
      color: #757575;
    }
  }
`

export const Icon = styled.img`
  width: 60px;
  border-radius: 8px;
`

export const TextGradient = styled.span`
  color: #2fbdf4;
`

export const MyActions = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const Link = ({ txHash }: { txHash: string }) => (
  <div>
    View on Wanchain Explorer{' '}
    <a
      target="_blank"
      rel="noreferrer"
      href={`${process.env.REACT_APP_WANSCAN_API || 'https://www.wanscan.org'}/tx/${txHash}`}
    >
      <Img width={18} src={LinkIcon} alt="link" />
    </a>
  </div>
)
